import React, { useEffect, useState } from 'react';
import { Card, CardContent, Typography, Box, Skeleton, Chip, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { paperTradingApi, BudgetOverview } from '../../../services/paperTradingApi';

const ActiveStrategies: React.FC = () => {
  const [budget, setBudget] = useState<BudgetOverview | null>(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    paperTradingApi.getBudget()
      .then(setBudget)
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <Card sx={{ borderRadius: 3 }}>
        <CardContent>
          <Skeleton variant="text" width={150} />
          <Skeleton variant="rectangular" height={120} sx={{ mt: 2, borderRadius: 2 }} />
        </CardContent>
      </Card>
    );
  }

  const strategies = budget?.strategies ?? [];

  return (
    <Card sx={{ borderRadius: 3 }}>
      <CardContent>
        <Typography variant="h6" fontWeight={600} gutterBottom>Aktive Strategien</Typography>

        {strategies.length === 0 ? (
          <Box sx={{ textAlign: 'center', py: 3 }}>
            <Typography variant="body2" color="text.secondary" gutterBottom>Noch keine Strategien erstellt</Typography>
            <Button
              variant="outlined"
              size="small"
              href="/strategies"
              sx={{ mt: 1, textTransform: 'none', borderRadius: 2 }}
            >
              Erste Strategie erstellen
            </Button>
          </Box>
        ) : (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
            {strategies.map((s) => {
              const pnl = (s.budget_used_eur || 0) > 0 ? s.budget_used_eur : 0;
              const remaining = (s.budget_eur || 0) - (s.budget_used_eur || 0);
              return (
                <Box
                  key={s.id}
                  onClick={() => navigate('/strategies')}
                  sx={{
                    p: 1.5, borderRadius: 2, cursor: 'pointer',
                    bgcolor: 'action.hover',
                    borderLeft: 3,
                    borderColor: s.is_active ? 'success.main' : 'text.disabled',
                    '&:hover': { bgcolor: 'action.selected' },
                  }}
                >
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Box>
                      <Typography variant="subtitle2" fontWeight={600}>{s.name}</Typography>
                      <Typography variant="caption" color="text.secondary">
                        {(s.strategy_type || 'unknown').toUpperCase()} · {(s as any).market || '—'} · Budget: €{(s.budget_used_eur || 0).toFixed(2)}/€{(s.budget_eur || 0).toFixed(2)}
                      </Typography>
                    </Box>
                    <Chip
                      label={s.is_active ? 'Aktiv' : 'Gestoppt'}
                      size="small"
                      color={s.is_active ? 'success' : 'default'}
                      variant="outlined"
                    />
                  </Box>
                </Box>
              );
            })}
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default ActiveStrategies;
